import { LocationsMap } from "../google-map/google-map.component";

export const objData = [
  {
    section: "North America",
    active: true,
  },
  {
    section: "Europe, Asia & Pacific",
    active: false,
  },
];
